const baseStyle = {
    container: {
        dislplay: 'inline'
    }
};
const defaultProps = {
    size: 'md',
    variant: 'dark'
};
const parts = ['container', 'icon', 'text'];
const variants = {
    dark: {
        container: {
            color: `seaBlue.main`
        }
    },
    light: {
        container: {
            color: `digiGreen.main`
        }
    },
    white: {
        container: {
            color: `white`
        }
    },
    plain: {
        container: {
            hoverTextDecoration: 'none'
        }
    }
};
const sizes = {
    sm: {
        container: {
            fontSize: 'xs',
            lineHeight: '16px'
        },
        icon: {
            size: 'xs'
        }
    },
    md: {
        container: {
            fontSize: 'sm',
            lineHeight: '20px'
        },
        icon: {
            size: 'xs'
        }
    },
    lg: {
        container: {
            fontSize: 'md',
            lineHeight: '24px'
        },
        icon: {
            size: 'sm'
        }
    },
    xl: {
        container: {
            fontSize: 'lg',
            lineHeight: '28px'
        },
        icon: {
            size: 'sm'
        }
    }
};
export default {
    baseStyle,
    defaultProps,
    parts,
    sizes,
    variants
};
